import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.content}/v4/`, {
  get: {
    'file.fetchPrivateLink': 'files/:fileId',
    'file.fetchEntityByType': 'files/entity/:entityId/:type',
    'file.status': 'upload/file/:fileId/media-status'
  },
  delete: {
    'file.delete': 'entity/:entityId/file/:fileId'
  }
});

Request.register(`${Settings.api.fileClub}/v4/files/`, {
  get: {
    'file.downloadUrl': 'download-url/:fileId'
  }
});

Request.register(`${Settings.api.fileClub}/public/v5/`, {
  get: {
    'file.public.thumbor': 'url/:fileId/thumbor'
  }
});
